<template>
    <div class="dropdown" @mouseover="isOpen = true" @mouseleave="isOpen = false">  
        <a href="/shop/" class="button-dropdown el" v-if="!isOpen">
                {{ title }}
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path d="M310.6 246.6l-127.1 128C176.4 380.9 168.2 384 160 384s-16.38-3.125-22.63-9.375l-127.1-128C.2244 237.5-2.516 223.7 2.438 211.8S19.07 192 32 192h255.1c12.94 0 24.62 7.781 29.58 19.75S319.8 237.5 310.6 246.6z"/></svg>
        </a>
        <a href="/shop/" class="button-dropdown el" v-if="isOpen">
                {{ title }}
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path d="M9.39 265.4l127.1-128C143.6 131.1 151.8 128 160 128s16.38 3.125 22.63 9.375l127.1 128c9.156 9.156 11.9 22.91 6.943 34.88S300.9 320 287.1 320H32.01c-12.94 0-24.62-7.781-29.58-19.75S.2333 274.5 9.39 265.4z"/></svg>
        </a>
        <transition name="slide-up" appear>
            
            <div class="sidebar-drop" v-if="isOpen">
                
                <div class="side-cont">
                     
                <div class="menu-col"> 
                    <div class="menu-item2 cel">
                        <a href="/peripoiisi-prosopou/"><font-awesome-icon icon="fa-solid fa-circle-arrow-right" /><strong>ΠΕΡΙΠΟΙΗΣΗ ΠΡΟΣΩΠΟΥ</strong></a>
                    </div> 
                    <div class="menu-item1">
                        <a href="/beautyblenders/"><font-awesome-icon icon="fa-solid fa-circle-arrow-right" />Beautyblenders</a>
                    </div>
                    <div class="menu-item1">
                        <a href="/tsimpidakia-fridion/"><font-awesome-icon icon="fa-solid fa-circle-arrow-right" />Τσιμπιδάκια Φρυδιών</a>
                    </div>
                    

                    <!-- third menu -->
                     <div class="menu-item2 cel">
                        <a href="/eidi-spitiou/"><font-awesome-icon icon="fa-solid fa-circle-arrow-right" /><strong>ΕΙΔΗ ΣΠΙΤΙΟΥ</strong></a>
                    </div> 
                    <div class="menu-item1">
                        <a href="/vafes-papoutsion/"><font-awesome-icon icon="fa-solid fa-circle-arrow-right" />Βαφές Παπουτσιών</a>
                    </div>
                    <div class="menu-item1">
                        <a href="/trapoules/"><font-awesome-icon icon="fa-solid fa-circle-arrow-right" />Τράπουλες</a>
                    </div>
                    <div class="menu-item1">
                        <a href="/kouzina-mpanio/"><font-awesome-icon icon="fa-solid fa-circle-arrow-right" />Κουζίνα – Μπάνιο</a>
                    </div>
                    <div class="menu-item1">
                        <a href="/kolles/"><font-awesome-icon icon="fa-solid fa-circle-arrow-right" />Κόλλες</a>
                    </div>
                   
                    <!-- -->
                     <div class="menu-item2 cel">
                        <a href="/bataries/"><font-awesome-icon icon="fa-solid fa-circle-arrow-right" /><strong>ΜΠΑΤΑΡΙΕΣ</strong></a>
                    </div> 
                    <div class="menu-item1">
                        <a href="/alkalikes-mpataries/"><font-awesome-icon icon="fa-solid fa-circle-arrow-right" />Αλκαλικές Μπαταρίες</a>
                    </div>
                    <div class="menu-item1">
                        <a href="/alkalikes-mpataries-12volt/"><font-awesome-icon icon="fa-solid fa-circle-arrow-right" />Αλκαλικές Μπαταρίες 12Volt</a>
                    </div>
                    <div class="menu-item1">
                        <a href="/alkalikes-mpataries-ag/"><font-awesome-icon icon="fa-solid fa-circle-arrow-right" />Αλκαλικές Μπαταρίες AG 1.55Volt</a>
                    </div>
                    <div class="menu-item1">
                        <a href="/epanafortizomenes-mpataries/"><font-awesome-icon icon="fa-solid fa-circle-arrow-right" />Επαναφορτιζόμενες Μπαταρίες</a>
                    </div>
                    <div class="menu-item1">
                        <a href="/mpataries-lithiou-cb-3vold/"><font-awesome-icon icon="fa-solid fa-circle-arrow-right" />Μπαταρίες Λιθίου CR 3Volt</a>
                    </div>
                    <!-- -->
                    <div class="menu-item2 per">
                        <a href="/kathreftes/"><font-awesome-icon icon="fa-solid fa-circle-arrow-right" /><strong>ΚΑΘΡΕΦΤΕΣ</strong></a>
                    </div> 
                    <div class="menu-item1">
                        <a href="/kathreftes-makigiaz/"><font-awesome-icon icon="fa-solid fa-circle-arrow-right" /><strong>Καθρέφτες Μακιγιάζ</strong></a>
                    </div> 
                     <div class="menu-item1">
                        <a href="/kathreftes-me-fos/"><font-awesome-icon icon="fa-solid fa-circle-arrow-right" /><strong>Καθρέφτες Με Φώς</strong></a>
                    </div>                     
                    <div class="menu-item1">
                        <a href="/kathreftakia-tsantas/"><font-awesome-icon icon="fa-solid fa-circle-arrow-right" /><strong>Καθρεφτάκια Τσάντας</strong></a>
                    </div> 
                    
                </div>
                <div class="menu-col1 el">
                    <div class="menu-item2 let">
                        <a href="/psalidia/"><font-awesome-icon icon="fa-solid fa-circle-arrow-right" /><strong>ΨΑΛΙΔΙΑ</strong></a>
                    </div> 
                    <div class="menu-item1">
                        <a href="/psalidia-raptikis/"><font-awesome-icon icon="fa-solid fa-circle-arrow-right" />Ψαλίδια Ραπτίκης</a>
                    </div>
                    <div class="menu-item1">
                        <a href="/psalidia-kourematos/"><font-awesome-icon icon="fa-solid fa-circle-arrow-right" />Ψαλίδια Κουρέματος</a>
                    </div>

                    <!-- second menu -->
                    <div class="menu-item2 let">
                        <a href="/anemistirakia-mini-fans/"><font-awesome-icon icon="fa-solid fa-circle-arrow-right" /><strong>ΑΝΕΜΙΣΤΗΡΑΚΙΑ - MiNi FANS</strong></a>
                    </div> 
                    <div class="menu-item1">
                        <a href="/anemistirakia-xeiros-epanafortizomena/"><font-awesome-icon icon="fa-solid fa-circle-arrow-right" />Ανεμιστηράκια Χειρός Επαναφορτιζόμενα</a>
                    </div>
                    <div class="menu-item1">
                        <a href="/anemistirakia-xeiros-mpatarias/"><font-awesome-icon icon="fa-solid fa-circle-arrow-right" />Ανεμιστηράκια Χειρός Μπαταρίας</a>
                    </div>
                    <!-- 3 -->
                    
                   
                    
                    <!-- -->
                    
                    <div class="menu-item2 let">
                        <a href="/fakoi-labes/"><font-awesome-icon icon="fa-solid fa-circle-arrow-right" /><strong>ΦΑΚΟΙ - ΛΑΜΠΕΣ</strong></a>
                    </div> 
                    <div class="menu-item1">
                        <a href="/fakoi-epanafortizomenoi/"><font-awesome-icon icon="fa-solid fa-circle-arrow-right" />Φακοί Επαναφορτιζόμενοι</a>
                    </div>
                    <div class="menu-item1">
                        <a href="/fakoi-mpatarias/"><font-awesome-icon icon="fa-solid fa-circle-arrow-right" />Φακοί Μπαταρίας</a>
                    </div>
                    
                     <div class="menu-item2 let">
                        <a href="/manikiour-pentikiour/"><font-awesome-icon icon="fa-solid fa-circle-arrow-right" /><strong>ΜΑΝΙΚΙΟΥΡ - ΠΕΝΤΙΚΙΟΥΡ</strong></a>
                    </div> 
                    <div class="menu-item1">
                        <a href="/pensakia-paranixidon/"><font-awesome-icon icon="fa-solid fa-circle-arrow-right" />Πενσάκια Παρανυχίδων</a>
                    </div>
                    <div class="menu-item1">
                        <a href="/pensakia-nixion/"><font-awesome-icon icon="fa-solid fa-circle-arrow-right" />Πενσάκια Νυχιών</a>
                    </div>
                    <div class="menu-item1">
                        <a href="/psalidakia-nixion/"><font-awesome-icon icon="fa-solid fa-circle-arrow-right" />Ψαλιδάκια Νυχιών</a>
                    </div>
                    <div class="menu-item1">
                        <a href="/raspes-podion/"><font-awesome-icon icon="fa-solid fa-circle-arrow-right" />Ράσπες Ποδιών</a>
                    </div>
                    <div class="menu-item1">
                        <a href="/limes-nixion/"><font-awesome-icon icon="fa-solid fa-circle-arrow-right" />Λίμες Νυχιών</a>
                    </div>
                    <div class="menu-item1">
                        <a href="/nixokoptes/"><font-awesome-icon icon="fa-solid fa-circle-arrow-right" />Νυχοκόπτες</a>
                    </div>
                </div>

                <div class="menu-col1">
                    <div class="menu-item2 per">
                        <a href="/sirmata-ilektrodia/"><font-awesome-icon icon="fa-solid fa-circle-arrow-right" /><strong>ΗΛΕΚΤΡΟΝΙΚΑ ΕΙΔΗ</strong></a>
                    </div> 
                    <div class="menu-item1">
                        <a href="/akoustika-bluetooth/"><font-awesome-icon icon="fa-solid fa-circle-arrow-right" /><strong>Ακουστικά Bluetooth</strong></a>
                    </div> 
                     <div class="menu-item1">
                        <a href="/akoustika-handsfree/"><font-awesome-icon icon="fa-solid fa-circle-arrow-right" /><strong>Ακουστικά HandsFree</strong></a>
                    </div>                     
                    <div class="menu-item1">
                        <a href="/fortistes/"><font-awesome-icon icon="fa-solid fa-circle-arrow-right" /><strong>Φορτιστές</strong></a>
                    </div> 
                    <div class="menu-item1">
                        <a href="/kalodia-fortisis/"><font-awesome-icon icon="fa-solid fa-circle-arrow-right" /><strong>Καλώδια Φόρτισης</strong></a>
                    </div> 
                    <div class="menu-item2 per">
                        <a href="/axesouar-mallion/"><font-awesome-icon icon="fa-solid fa-circle-arrow-right" /><strong>ΑΞΕΣΟΥΑΡ ΜΑΛΛΙΩΝ</strong></a>
                    </div> 
                    <div class="menu-item1">
                        <a href="/pinela-vafis/"><font-awesome-icon icon="fa-solid fa-circle-arrow-right" /><strong>Πινέλα Βαφής</strong></a>
                    </div>
                    <div class="menu-item1">
                        <a href="/vourtses-mallion/"><font-awesome-icon icon="fa-solid fa-circle-arrow-right" /><strong>Βούρτσες Μαλλιών</strong></a>
                    </div>
                    <div class="menu-item1">
                        <a href="/lastixakia-mallion/"><font-awesome-icon icon="fa-solid fa-circle-arrow-right" /><strong>Λαστιχάκια Μαλλιών</strong></a>
                    </div>
                    <div class="menu-item1">
                        <a href="/xtenes-mallion/"><font-awesome-icon icon="fa-solid fa-circle-arrow-right" /><strong>Χτένες Μαλλιών</strong></a>
                    </div>
                    <div class="menu-item1">
                        <a href="/tsimpidakia-mallion/"><font-awesome-icon icon="fa-solid fa-circle-arrow-right" /><strong>Τσιμπιδάκια Μαλλιών</strong></a>
                    </div>
                    <div class="menu-item1">
                        <a href="/stekes-mallion/"><font-awesome-icon icon="fa-solid fa-circle-arrow-right" /><strong>Στέκες Μαλλιών</strong></a>
                    </div>
                    <div class="menu-item1">
                        <a href="/klamer-mallion/"><font-awesome-icon icon="fa-solid fa-circle-arrow-right" /><strong>Κλάμερ Μαλλιών</strong></a>
                    </div>
 
                    <div class="menu-item2 per">
                        <a href="/neseser-taxidiou-kallyntikon/"><font-awesome-icon icon="fa-solid fa-circle-arrow-right" /><strong>ΝΕΣΕΣΕΡ ΤΑΞΙΔΙΟΥ - ΚΑΛΛΥΝΤΙΚΩΝ</strong></a>
                    </div> 
                    <div class="menu-item1">
                        <a href="/andrika-neseser/"><font-awesome-icon icon="fa-solid fa-circle-arrow-right" /><strong>Ανδρικά Νεσεσέρ</strong></a>
                    </div>
                    <div class="menu-item1">
                        <a href="/ginekia-neseser/"><font-awesome-icon icon="fa-solid fa-circle-arrow-right" /><strong>Γυναικεία Νεσεσέρ</strong></a>
                    </div>   
                     <div class="menu-item2 cel">
                        <a href="/rologia/"><font-awesome-icon icon="fa-solid fa-circle-arrow-right" /><strong>ΡΟΛΟΓΙΑ</strong></a>
                    </div> 
                    <div class="menu-item1">
                        <a href="/rologia-xipnitiria/"><font-awesome-icon icon="fa-solid fa-circle-arrow-right" />Ρολόγια Ξυπνητήρια</a>
                    </div>
                    <!-- second menu -->

                </div>
                <div class="menu-col1 menu-last">
                   
                </div>
                
                
                
            </div>
            
            </div>
            
        </transition>
         <div class="scroll-type6">
            <div class="scroll-icon">
                <img src="/wp-content/uploads/2025/01/32213.png" alt="">
            </div>
        </div>
        <!--<transition name="slide-up" appear>
            <div class="sidebar-drop" v-if="isOpen">
                <div class="side-cont">
                <div class="menu-col"> 
                    <div class="menu-item2 cel">
                        <a href="/celebrate-freshness/"><font-awesome-icon icon="fa-solid fa-circle-arrow-right" /><strong>CELEBRATE FRESHNESS</strong></a>
                    </div> 
                    <div class="menu-item1">
                        <a href="/collagen-chews/"><font-awesome-icon icon="fa-solid fa-circle-arrow-right" />COLLAGEN CHEWS</a>
                    </div>
                    <div class="menu-item1">
                        <a href="/happy-yak/"><font-awesome-icon icon="fa-solid fa-circle-arrow-right" />HAPPY YAK</a>
                    </div>
                    <div class="menu-item1">
                        <a href="/olive-woods/"><font-awesome-icon icon="fa-solid fa-circle-arrow-right" />OLIVE WOODS</a>
                    </div>
                    
                    <div class="menu-item1">
                        <a href="/snack-n-bark/"><font-awesome-icon icon="fa-solid fa-circle-arrow-right" />SNACK N BARK</a>
                    </div>
                    <div class="menu-item1">
                        <a href="/super-premium-snacks/"><font-awesome-icon icon="fa-solid fa-circle-arrow-right" />SUPER PREMIUM SNACKS</a>
                    </div>
                    <div class="menu-item1">
                        <a href="/the-barkers/"><font-awesome-icon icon="fa-solid fa-circle-arrow-right" />THE BARKERS</a>
                    </div>
                    <div class="menu-item1">
                        <a href="/wild-antler/"><font-awesome-icon icon="fa-solid fa-circle-arrow-right" />WILD ANTLER</a>
                    </div>
                    <div class="menu-item1">
                        <a href="/ladi-solomou/"><font-awesome-icon icon="fa-solid fa-circle-arrow-right" />ΛΑΔΙ ΣΟΛΩΜΟΥ</a>
                    </div>                 

                </div>
                <div class="menu-col1 el">
                    <div class="menu-item2 let">
                        <a href="/europremium/"><font-awesome-icon icon="fa-solid fa-circle-arrow-right" /><strong>EUROPREMIUM</strong></a>
                    </div> 
                    <div class="menu-item1">
                        <a href="/dry/"><font-awesome-icon icon="fa-solid fa-circle-arrow-right" />DRY</a>
                    </div>
                    <div class="menu-item1">
                        <a href="/snacks/"><font-awesome-icon icon="fa-solid fa-circle-arrow-right" />SNACKS</a>
                    </div>
                    <div class="menu-item2 marg">
                        <a href="/aatu/"><font-awesome-icon icon="fa-solid fa-circle-arrow-right" /><strong>AATU</strong></a>
                    </div> 
                    <div class="menu-item1">
                        <a href="/aatu-cat/"><font-awesome-icon icon="fa-solid fa-circle-arrow-right" />AATU CAT</a>
                    </div>
                    <div class="menu-item1">
                        <a href="/aatu-dog/"><font-awesome-icon icon="fa-solid fa-circle-arrow-right" />AATU DOG</a>
                    </div>
                     <div class="menu-item2 marg">
                        <a href="/shop/"><font-awesome-icon icon="fa-solid fa-circle-arrow-right" /><strong>ΠΑΙΧΝΙΔΙΑ</strong></a>
                    </div> 
                    <div class="menu-item1">
                        <a href="/nylabone/"><font-awesome-icon icon="fa-solid fa-circle-arrow-right" /><strong>NYLABONE</strong></a>
                    </div> 
                    <div class="menu-item1">
                        <a href="/pawise/"><font-awesome-icon icon="fa-solid fa-circle-arrow-right" /><strong>PAWISE</strong></a>
                    </div> 
                </div>
                <div class="menu-col1 menu-last en">
                    <div class="menu-item2 per">
                        <a href="/shop"><font-awesome-icon icon="fa-solid fa-circle-arrow-right" /><strong>ΠΕΡΙΣΣΟΤΕΡΑ ΠΡΟΪΟΝΤΑ</strong></a>
                    </div> 
                    <div class="menu-item1">
                        <a href="/ambrosia/"><font-awesome-icon icon="fa-solid fa-circle-arrow-right" /><strong>AMBROSIA</strong></a>
                    </div> 
                     <div class="menu-item1">
                        <a href="/barking-heads-meowing-heads/"><font-awesome-icon icon="fa-solid fa-circle-arrow-right" /><strong>BARKING HEADS & MEOWING HEADS</strong></a>
                    </div>                     
                    <div class="menu-item1">
                        <a href="/savic/"><font-awesome-icon icon="fa-solid fa-circle-arrow-right" /><strong>SAVIC</strong></a>
                    </div> 
                    <div class="menu-item1">
                        <a href="/yow-up/"><font-awesome-icon icon="fa-solid fa-circle-arrow-right" /><strong>YOW UP</strong></a>
                    </div> 
                    <div class="menu-item1">
                        <a href="/dolina-piper-rafi/"><font-awesome-icon icon="fa-solid fa-circle-arrow-right" /><strong>DOLINA-PIPER-RAFI
                        </strong></a>
                    </div> 
                    <div class="menu-item1">
                        <a href="/egeo-pet-food/"><font-awesome-icon icon="fa-solid fa-circle-arrow-right" /><strong>EGEO PET FOOD
                        </strong></a>
                    </div>
                    <div class="menu-item1">
                        <a href="/inaba/"><font-awesome-icon icon="fa-solid fa-circle-arrow-right" /><strong>INABA
                        </strong></a>
                    </div>
                    <div class="menu-item1">
                        <a href="/reflex-enjoy-proline/"><font-awesome-icon icon="fa-solid fa-circle-arrow-right" /><strong>REFLEX-ENJOY-PROLINE
                        </strong></a>
                    </div>
                    <div class="menu-item1">
                        <a href="/natural-trainer/"><font-awesome-icon icon="fa-solid fa-circle-arrow-right" /><strong>NATURAL TRAINER
                        </strong></a>
                    </div>
                    <div class="menu-item1">
                        <a href="/perfect-care/"><font-awesome-icon icon="fa-solid fa-circle-arrow-right" /><strong>PERFECT CARE</strong></a>
                    </div>

                </div>
                <div class="menu-col4 en">
                    
                </div>
            </div>
            </div>
        </transition>-->
        
    </div>
</template>


<script>

export default ({
    name: 'sidebar-right',
    props: ['title', 'items','itemsen','titlen'],
    data () {
        return{
            isOpen: false,
            secondTime: true
        }
    }
})

</script>

<style>
.scroll-type6 {
  position: relative;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  cursor: pointer;
  background: #ffffff;
  border: 5px solid #3b78a3;
}
.scroll-type6 img{
    width:25px;
    height: auto;
    transform: rotate(90deg);
    filter: invert(62%) sepia(59%) saturate(380%) hue-rotate(164deg) brightness(69%) contrast(90%);
}
.scroll-type6::before {
  display: block;
  content: "";
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: #6aabda;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translateX(-50%) translateY(-50%);
  z-index: -1;
  animation: scale 1.6s ease-in infinite;
}
@keyframes scale {
  0% {
    opacity: 1;
    transform: translateX(-50%) translateY(-50%) scale(1);
  }
  40% {
    opacity: 1;
    transform: translateX(-50%) translateY(-50%) scale(1.2);
  }
  100% {
    opacity: 0;
    transform: translateX(-50%) translateY(-50%) scale(2);
  }
}
.scroll-type6 .scroll-icon {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.scroll-type6 .scroll-icon svg {
  color: #333333;
}



.side-cont{
    position: relative;
}
@font-face {
    font-family: 'Play-Regular';
    src: url('Play-Regular.woff2') format('woff2');
}
*{
  scrollbar-width: thin !important;
  font-family: 'Play-Regular' !important;  
}
.img-text{
    display: flex;
    gap:15px !important;
    padding-left: 40px;
    margin-bottom: 25px;
}
.menu-col{
    width: 65% !important;
    padding-top: 50px !important;
    padding-left: 240px !important;
}

.menu-col1{
    width: 35% !important;
    padding-right: 240px !important;
    border-left: 1px solid #e5e5e5;
    padding-top: 50px;
    padding-bottom: 25px;
}
.menu-item1{
    display: flex;
}

    .dropdown{
        text-align: center;
    }
    .button-dropdown {
        font-size: 40px;
        text-decoration: none;
        color:#222 !important;
        display: inline-block;
        position: relative;
    }
 
 .button-dropdown:after {
    content: '';
    position: absolute;
    width: 100%;
    transform: scaleX(0);
    height: 1px;
    bottom: 0;
    left: 0;
    background-color: #222;
    transform-origin: bottom right;
    transition: transform 0.25s ease-out;
}

.button-dropdown:hover:after{
  transform: scaleX(1);
  transform-origin: bottom left;
}
    .button-dropdown svg{
        margin-left: 10px;
        width:15px !important;
        filter:none !important;
    }
    .menu-item svg{
        width:10px !important;
        
    }
    .menu-btn{
        padding-left:10px !important;
    }
    .sidebar-drop img{
        width: 120px !important;
        height: 90px !important;
        object-fit: cover;
        border-radius: 5px !important;
    }
    .sidebar-drop{
        border-top: 1px solid #e7e7e7;
        background-color: #fffdfd;
        width:100% !important;
        z-index: 99;
        box-shadow: 1px 3px 3px rgb(0 0 0 / 21%);
        margin-left: auto;
        margin-right: auto;
        text-align: left;
        padding: 0px 0;
        margin-top: 20px;
        overflow: scroll;
        display: flex;
        overflow-x: hidden;
        scrollbar-width: thin !important;
    }
 

   
    .sidebar-drop .menu-item1 {
        font-size: 20px;
        padding: 9px 40px;
        font-weight: 600;
    }

    .sidebar-drop .menu-item1 a{
       text-align: left;
       text-decoration: none;
       color:#222;
       display: inline-block;
       padding-bottom:5px;
       position: relative;
    }
    .title-text a{
        text-decoration: none;
        color:#222 !important
    }
    .title-text a:hover{
        color:#719452 !important
    }
    /* .sidebar-drop .menu-item1 a:after {
        content: '';
        position: absolute;
        width: 100%;
        transform: scaleX(0);
        height: 1px;
        bottom: 0;
        left: 0;
        background-color: #222;
        transform-origin: bottom right;
        transition: transform 0.25s ease-out;
    }*/

    .sidebar-drop .menu-item1 a:hover:after{
        transform: scaleX(1);
        transform-origin: bottom left;
    }
    .sidebar-drop.menu-item1:hover{
        background-color: #fff;
        color:#222;     
    }
    .sidebar-drop .menu-item1 a:hover{
        color:#719452 !important
    }
    .slide-up-enter-active,
    .slide-up-leave-active {
        transition: all 0.4s ease-out;
    }

.slide-up-enter,.slide-up-leave-to{
  opacity: 0;
  transform: translateY(30px);
}
.sidebar-drop .myico {
    width: 33px !important;
    height: auto !important;
    min-width: 33px !important;
    background: #1c6aa3;
    border-radius: 50% !important;
    padding: 4px;
    box-shadow: -2px 2px #91bee0 !important;
}
.menu-item2 a{
    display: flex !important;
    align-items: center !important;
    gap:10px !important
}
/*.menu-item2.menu-item2 img{
    filter: invert(10%) sepia(75%) saturate(1016%) hue-rotate(185deg) brightness(98%) contrast(93%) !important;
}*/

.rot{
    transform: rotate(345deg);
}

/*
.slide-up-leave-to {
  opacity: 0;
  transform: translateY(-30px);
}*/

@media only screen and (max-width: 767px) {
    nav .menu-item1 .sidebar{
        width:100% !important;
    }
}

</style>